import type {AccessTokenService} from '@/domain/interfaces/AccessTokenService';

export class LocalStorageAccessTokenService implements AccessTokenService {
  constructor(private readonly ACCESS_TOKEN_KEY: string) {}
  get = () => {
    const accessToken = localStorage.getItem(this.ACCESS_TOKEN_KEY);

    return Promise.resolve(accessToken || undefined);
  };
  set = (token: string | undefined) => {
    if (token) localStorage.setItem(this.ACCESS_TOKEN_KEY, token);
    return Promise.resolve();
  };
  remove = () => {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    return Promise.resolve();
  };
}
